import React from "react";

export const SecurityIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-4 h-4 text-gray-50",
    ...props
}) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6.66659V5.33325C4 3.12659 4.66667 1.33325 8 1.33325C11.3333 1.33325 12 3.12659 12 5.33325V6.66659" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.00065 12.3333C8.92113 12.3333 9.66732 11.5871 9.66732 10.6667C9.66732 9.74619 8.92113 9 8.00065 9C7.08018 9 6.33398 9.74619 6.33398 10.6667C6.33398 11.5871 7.08018 12.3333 8.00065 12.3333Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.334 14.6667H4.66732C2.00065 14.6667 1.33398 14.0001 1.33398 11.3334V10.0001C1.33398 7.33341 2.00065 6.66675 4.66732 6.66675H11.334C14.0007 6.66675 14.6673 7.33341 14.6673 10.0001V11.3334C14.6673 14.0001 14.0007 14.6667 11.334 14.6667Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    );
};